// src/pages/LogoutPage.jsx
import React, { useEffect } from 'react';
import { useNavigate } from 'react-router-dom';
import { useAuth } from '../contexts/AuthContext';
import { LogOut, Loader2 } from 'lucide-react';

function LogoutPage() {
  const navigate = useNavigate();
  const { logout } = useAuth();

  useEffect(() => {
    const handleLogout = async () => {
      try {
        await logout();
        // Wait a moment before redirecting for UX
        setTimeout(() => {
          navigate('/login');
        }, 1500);
      } catch (error) {
        console.error('Logout error:', error);
        navigate('/login');
      }
    };

    handleLogout();
  }, [logout, navigate]);

  return (
    <div className="min-h-screen bg-gradient-to-br from-[#FAFAFA] via-white to-[#18365E]/5 flex items-center justify-center px-4">
      <div className="text-center">
        <div className="inline-flex items-center justify-center w-16 h-16 rounded-2xl bg-gradient-to-br from-[#18365E] to-[#FF6E4C] mb-4 shadow-lg">
          <LogOut className="w-8 h-8 text-white" />
        </div>
        <h2
          className="text-2xl mb-2"
          style={{ fontWeight: 700, color: '#18365E', fontFamily: 'Montserrat, sans-serif' }}
        >
          Signing Out
        </h2>
        <div className="flex items-center justify-center gap-2 text-[#717182]">
          <Loader2 className="w-5 h-5 animate-spin" />
          <p className="text-sm" style={{ fontWeight: 500 }}>
            Thank you for using DVA
          </p>
        </div>
      </div>
    </div>
  );
}

export default LogoutPage;